import React from 'react';
import { useWorldStore } from '../stores/worldStore';
import { getChannel } from '../services/realtimeManager';
import { Check, X } from 'lucide-react';

const KnockNotification: React.FC<{ worldId: string }> = ({ worldId }) => {
  const knockRequests = useWorldStore((s: any) => s.knockRequests) as Array<{ userId: string; userName: string; timestamp: number }>;
  const removeKnockRequest = useWorldStore((s: any) => s.removeKnockRequest) as (userId: string) => void;

  if (knockRequests.length === 0) return null;

  const respond = (userId: string, approved: boolean) => {
    const channel = getChannel(worldId);
    channel.send({
      type: 'broadcast',
      event: 'knock:response',
      payload: { targetUserId: userId, approved },
    });
    removeKnockRequest(userId);
  };

  return (
    <div style={{
      position: 'fixed', top: 80, right: 20, zIndex: 200,
      display: 'flex', flexDirection: 'column', gap: 8,
      maxWidth: 320,
    }}>
      {knockRequests.map((req) => (
        <div key={req.userId} style={{
          padding: '14px 16px',
          background: 'rgba(5, 14, 24, 0.92)',
          backdropFilter: 'blur(20px)',
          borderRadius: 12,
          border: '1px solid rgba(0, 194, 179, 0.25)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
          color: 'white',
          animation: 'slideInRight 0.3s ease',
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
            {req.userName} is knocking
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 10 }}>
            Requesting entry to your world
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => respond(req.userId, true)}
              style={{
                flex: 1, padding: '8px 12px',
                background: 'rgba(74, 222, 128, 0.15)',
                border: '1px solid rgba(74, 222, 128, 0.3)',
                borderRadius: 8, color: '#4ade80',
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
              }}
            >
              <Check size={14} /> Allow
            </button>
            <button
              onClick={() => respond(req.userId, false)}
              style={{
                flex: 1, padding: '8px 12px',
                background: 'rgba(255, 59, 48, 0.12)',
                border: '1px solid rgba(255, 59, 48, 0.3)',
                borderRadius: 8, color: '#ff6b6b',
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
              }}
            >
              <X size={14} /> Deny
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KnockNotification;
